module.exports = __webpack_public_path__ + "img/icon-stats-tickets.a234362b.svg";